import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

type selectedType = SelectOptionType & {
    group_code: string 
}

export const useDropdownGroupAsset = () => {
  const api = useApi()
  const [data, setData] = useState<selectedType[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    api.get("/groupasset/")
    .then((res: SuccessFetch<{ payload: { mr_group_id: number, mr_group_name: string, mr_group_code: string }[] }>) => { 
      setData(res.data.payload.map(item => { 
        return { 
            label: item.mr_group_name, 
            value: item.mr_group_id.toString(), 
            group_code: item.mr_group_code 
        }}))
    })
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}